import { useContext } from 'react';

import { UserContext } from '~/components/providers/UserProvider';
import { usePaginatedQuery } from '~/domains/common/hooks/usePaginatedQuery';

import { getUserEntriesForContest } from '../domains/services/entries.service.api';
import { ContestQueryKeys } from '../constants/query';

type UseContestUserEntriesProps = {
  contestId: string;
  pageSize?: number;
  enabled?: boolean;
};

export const useContestUserEntries = ({
  contestId,
  pageSize = 150, // TODO - Pagination for the future
  enabled = true,
}: UseContestUserEntriesProps) => {
  const { user } = useContext(UserContext);
  const userId = user?.id;

  const data = usePaginatedQuery(
    {
      queryKey: ContestQueryKeys.ENTRIES_FOR_CURRENT_USER({ contestId, userId }),
      queryFn: ({ limit, offset }) => getUserEntriesForContest(contestId, userId, limit, offset),
      enabled: enabled && !!contestId && !!userId,
    },
    {
      pageSize,
    }
  );

  return data;
};
